import {
    LikeSectionState,
    initialLikeSectionState,
} from "@/mk2/apps/blogs/containers/LikeSection/LikeSection.reducers";
import { AppState } from "@/mk2/reducers";

export const getLikeSectionState = (
    state: AppState,
    entityType: string,
    entityId: number,
): LikeSectionState =>
    state.containers.blogs.shared.likeSections[`${entityType}/${entityId}`] ||
    initialLikeSectionState;
